import IconButton from "components/IconButton"
import React from "react"
import { TipoContratoEnum } from "services/ContratoService"
import { StatusOrdemServicoEnum } from "services/OrdemServicoService"
import { arvoreParaMatriz } from "services/Utils"
import { breadCrumbGrupo } from "services/Utils"
import { formatNumber } from "services/Utils"

function BreadCrumb({ itens }) {
  return itens.map((item, idx) => (
    <React.Fragment key={item.id}>
      <span className="badge badge-info text-wrap">
        <strong>{item.codigo}</strong> - {item.descricao}
      </span>
      {(idx < itens.length - 1) && ' → '}
    </React.Fragment>
  ))
}

export default function Item(props) {
  const { id, codigo, descricao, unidade, precoUnitarioFmt, quantidadeFmt, quantidadeExecutadaFmt,
    percentualExecucaoFmt, saldoExecucaoFmt, precoTotalPrevistoFmt, precoTotalExecutadoFmt, saldoCustoFmt,
    atribuidaExecucao, os, grupo, onClick, edit, tipoContrato } = props

  const mostrarFlagNaoAtribuida = (os.idStatus == StatusOrdemServicoEnum.EM_FASE_EXECUCAO && !atribuidaExecucao)
  const mostrarFlagNaoAtribuidaCorrecao = (os.idStatus == StatusOrdemServicoEnum.EM_FASE_CORRECAO && props.divergenciasPendentesCorrecao > 0 && !props.atribuidaCorrecao)

  return (
    <tr key={id}>
      <td>{codigo}</td>
      <td className="text-wrap">
        {descricao}&nbsp;
        <BreadCrumb itens={arvoreParaMatriz(grupo).reverse()} />
        {mostrarFlagNaoAtribuida && (
          <span className="ml-2 badge badge-danger">Não atribuída para execução</span>
        )}
        {mostrarFlagNaoAtribuidaCorrecao && (
          <span className="ml-2 badge badge-danger">Não atribuída para correção</span>
        )}
      </td>
      <td className="text-right">R$ {precoUnitarioFmt}</td>
      {tipoContrato == TipoContratoEnum.NORMAL ? (
        <>
          <td className="text-right">{quantidadeFmt} {unidade}</td>
          <td className="text-right">{quantidadeExecutadaFmt} {unidade}<br />{percentualExecucaoFmt}%</td>
          <td className="text-right">{saldoExecucaoFmt} {unidade}</td>
        </>
      ) : (
        <td className="text-right">{quantidadeExecutadaFmt} {unidade}</td>
      )}
      <td className="text-right">R$ {precoTotalPrevistoFmt}</td>
      <td className="text-right">R$ {precoTotalExecutadoFmt}</td>
      <td className="text-right">R$ {saldoCustoFmt}</td>
      <td>
        <div className="d-flex flex-row gap-5px justify-content-center">
          <IconButton alt="Detalhes" iconClass="bi-info-circle" onClick={() => onClick && onClick('detail', props)} />
          <IconButton alt="Histórico" iconClass="bi-card-list" onClick={() => onClick && onClick('history', props)} />
          {edit && (
            <>
              {tipoContrato == TipoContratoEnum.NORMAL && (
                <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => onClick && onClick('edit', props)} />
              )}
              <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => onClick && onClick('delete', props)} />
            </>
          )}
        </div>
      </td>
    </tr>
  )
}